// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__11BbJ","navBarLink":"footer_navBarLink__ccxOg"};